(function () {
  function initCaratShapes(section) {
    if (!section || section.dataset.caratShapesReady === 'true') return;
    section.dataset.caratShapesReady = 'true';

    const items = Array.from(section.querySelectorAll('[data-shape-item]'));
    const mobileImages = Array.from(section.querySelectorAll('.carat-shapes__ring-mobile .carat-shapes__ring-image'));
    const desktopImages = Array.from(section.querySelectorAll('.carat-shapes__right .carat-shapes__ring-image'));
    const cta = section.querySelector('[data-shape-cta]');
    const mobileBreakpoint = window.matchMedia('(max-width: 989px)');

    if (!items.length || !cta) return;

    let activeIndex = Math.max(
      0,
      items.findIndex((item) => item.dataset.defaultActive === 'true')
    );

    if (activeIndex < 0) activeIndex = 0;

    function updateImages(images, index) {
      images.forEach((image, i) => {
        image.classList.toggle('is-active', i === index);
      });
    }

    function updateActive(index) {
      if (index < 0 || index >= items.length || index === activeIndex) return;

      activeIndex = index;

      items.forEach((item, i) => {
        const isActive = i === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      updateImages(mobileImages, index);
      updateImages(desktopImages, index);

      const activeItem = items[index];
      const label = activeItem.dataset.shapeLabel || '';
      const link = activeItem.dataset.shapeLink || '#';
      const ctaPrefix = section.dataset.ctaPrefix || 'SHOP ALL';
      const ctaSuffix = section.dataset.ctaSuffix || 'JEWELLERY';

      cta.textContent = `${ctaPrefix} ${label.toUpperCase()} ${ctaSuffix}`.trim();
      cta.setAttribute('href', link);
      cta.setAttribute('aria-label', `${ctaPrefix} ${label} ${ctaSuffix}`.trim());
    }

    items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        if (!mobileBreakpoint.matches) updateActive(index);
      });

      item.addEventListener('focus', () => {
        updateActive(index);
      });

      item.addEventListener('click', (event) => {
        if (mobileBreakpoint.matches) {
          event.preventDefault();
          updateActive(index);

          item.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        } else {
          const link = item.dataset.shapeLink;
          if (link) window.location.href = link;
        }
      });
    });

    function setupMobileObserver() {
      const observerRoot = section.querySelector('[data-shape-grid-wrap]');
      if (!observerRoot || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          let strongest = null;

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            if (!strongest || entry.intersectionRatio > strongest.intersectionRatio) {
              strongest = entry;
            }
          });

          if (strongest) {
            const index = Number(strongest.target.dataset.shapeIndex);
            if (!Number.isNaN(index)) updateActive(index);
          }
        },
        {
          root: observerRoot,
          threshold: [0.6, 0.8]
        }
      );

      items.forEach((item) => observer.observe(item));

      mobileBreakpoint.addEventListener(
        'change',
        () => observer.disconnect(),
        { once: true }
      );
    }

    if (mobileBreakpoint.matches) setupMobileObserver();

    let resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateImages(mobileImages, activeIndex);
          updateImages(desktopImages, activeIndex);
        }, 160);
      },
      { passive: true }
    );
  }

  function boot() {
    const sections = Array.from(document.querySelectorAll('[data-carat-shapes]'));
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(initCaratShapes);
      return;
    }

    const sectionObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          initCaratShapes(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '350px 0px',
        threshold: 0.01
      }
    );

    sections.forEach(function (section) {
      sectionObserver.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();